import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@models/common/resultResponse";
import { ParameterTypesResponse } from "@/main/models/response/parameterTypesResponse";
import { saveParameters, saveParameterByTypeAndCompany, GetParameters, GetParameterByTypeAndCompany } from "./index";
import { parameterApi } from "@/main/api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getParametersSaga(action: GetParameters) {
	try {
		const response: AxiosResponse<Result<ParameterTypesResponse[]>> = yield call(
			parameterApi.getParameters,
			action.payload.request,
		);
		if (response.data.result) {
			yield put(saveParameters(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
			yield put(saveParameters(null, true, resultError.messagesDataError));
		}
	}
}

export function* getParametersByTypeAndCompanySaga(action: GetParameterByTypeAndCompany) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(parameterApi.getDomain, action.payload.request);
		if (response.data.result) {
			yield put(saveParameterByTypeAndCompany(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
			yield put(saveParameterByTypeAndCompany(null, true, resultError.messagesDataError));
		}
	}
}
